import Flex, { GAP_CLASS } from "components/Flex";
import { ALIGN_CLASS, DIRECTION_CLASS } from "components/Flex/Flex";
import UserAvatar from "components/UserAvatar";
import ChangeList from "layout/activityLog/components/ChangeList";
import { activityListPropsFrom } from "layout/activityLog/helpers";
import PropTypes from "prop-types";
import React from "react";
import { DATE_VARIANTS, formatDate } from "utils";
import { initialsFromName } from "utils/toInitials";

import styles from "./ActivityFeedRow.module.scss";

const ActivityFeedRow = ({ row }) => {
  const listProps = activityListPropsFrom(row.metadata);

  return (
    <li className={styles.activityFeedRow}>
      <Flex alignItems={ALIGN_CLASS["flex-start"]} gap={GAP_CLASS.GAP_300}>
        <UserAvatar
          initials={initialsFromName(row.actor.displayName)}
          name={row.actor.displayName}
        />
        <Flex
          direction={DIRECTION_CLASS.column}
          alignItems={ALIGN_CLASS["flex-start"]}
          gap={GAP_CLASS.GAP_100}
          className={styles.activityFeedRow__content}
        >
          <Flex
            alignItems={ALIGN_CLASS.baseline}
            gap={GAP_CLASS.GAP_200}
            className={styles.activityFeedRow__header}
          >
            <span className={styles.activityFeedRow__name}>
              {row.actor.displayName}
            </span>
            <span className={styles.activityFeedRow__date}>
              {formatDate(row.timestamp, DATE_VARIANTS.DOT_TIME)}
            </span>
          </Flex>
          <span className={styles.activityFeedRow__description}>
            {row.description}
          </span>
          {listProps && (
            <ChangeList
              {...listProps}
              className={styles.activityFeedRow__changeList}
            />
          )}
        </Flex>
      </Flex>
    </li>
  );
};

ActivityFeedRow.propTypes = {
  row: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    timestamp: PropTypes.string.isRequired,
    actor: PropTypes.shape({ displayName: PropTypes.string }).isRequired,
    description: PropTypes.node,
    metadata: PropTypes.shape({
      changes: PropTypes.array,
      responseCount: PropTypes.number,
      gates: PropTypes.array,
    }),
  }).isRequired,
};

export default ActivityFeedRow;
